import { Box } from '@wistia/ui';
import styled from 'styled-components';
import type { JSX } from 'react';

const Dot = styled.div<{ $isSelected: boolean }>`
  background-color: ${({ $isSelected }) =>
    $isSelected ? 'var(--wui-color-bg-fill)' : 'var(--wui-color-bg-surface-tertiary)'};
  border-radius: var(--wui-border-radius-rounded);
  height: 8px;
  width: ${({ $isSelected }) => ($isSelected ? '16px' : '8px')};
`;

export const Dots = ({ total, current }: { total: number; current: number }): JSX.Element => {
  const arr = new Array(total).fill(undefined);

  return (
    <Box gap="space-01">
      {arr.map((_, index) => (
        <Dot
          // eslint-disable-next-line react/no-array-index-key
          key={`dot-${index}`}
          $isSelected={current === index}
        />
      ))}
    </Box>
  );
};
